import { render } from "./GetFonts.vue?vue&type=template&id=56ec80ca"
import script from "./GetFonts.vue?vue&type=script&lang=js"
export * from "./GetFonts.vue?vue&type=script&lang=js"

import "./GetFonts.vue?vue&type=style&index=0&id=56ec80ca&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__